import { createAction } from 'redux-actions';
import { OrderTravellers } from '../types';

export const SET_TRAVELLERS = 'ORDER/SET_TRAVELLERS';

export const setTravellers = createAction<OrderTravellers>(SET_TRAVELLERS);

export type SetTravellersAction = ReturnType<typeof setTravellers>;
